import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { ANIM, COLORS, LAYOUT_CHROME } from '../../../../theme/tokens';

/* AI-credits header pill — sits to the right of the wallet balance inside the TopBar `Utils` row.
   Mirrors WalletLink/WalletAmount so the two read as siblings; the subtle Lumio spark stands in
   for a glyph. A button, since clicking it opens the credits modal (what they do + top up). */
export const Root = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  border-radius: 8px;
  transition: opacity ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:hover {
    opacity: 0.82;
  }
  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 3px;
  }
`;

export const Mark = styled.img`
  width: 18px;
  height: 18px;
  display: block;
`;

export const Amount = styled(Text).attrs({ tag: 'span' as const })`
  color: ${LAYOUT_CHROME.walletAmount};
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
`;
